import { Link } from "react-router-dom";
import { usePortalLoad } from "@/lib/portalApi";
import { fmt, fdate } from "@/lib/api";
import { PageHeader, StatusBadge } from "@/components/common";

export default function PortalInvoices() {
  const [d] = usePortalLoad("/invoices");
  if (!d) return null;
  return (
    <>
      <PageHeader title="Your invoices" subtitle={`From ${d.tenant.name}`} />
      <div className="space-y-3">
        {d.invoices.length === 0 && <p className="text-sm text-slate-400">No invoices yet.</p>}
        {d.invoices.map((i) => (
          <Link key={i.id} to={`/portal/invoices/${i.id}`} data-testid={`portal-invoice-${i.number}`} className="po-card flex flex-wrap items-center gap-4 p-5 transition-colors hover:border-[#45BFB4] fade-up">
            <div className="flex-1 min-w-[140px]"><div className="font-semibold text-slate-900">{i.number}</div><div className="text-xs text-slate-500">Due {fdate(i.due_date)}</div></div>
            <StatusBadge status={i.status} />
            {i.payment_claim?.status === "pending" && <StatusBadge status="pending" label="Payment claimed" />}
            <div className="text-right"><div className="po-label">Balance</div><div className="font-semibold tabular-nums">{fmt(i.status === "cancelled" ? 0 : i.total - i.amount_paid - (i.amount_credited || 0), i.currency)}</div></div>
            <div className="text-right"><div className="po-label">Total</div><div className="tabular-nums text-slate-600">{fmt(i.total, i.currency)}</div></div>
          </Link>
        ))}
      </div>
    </>
  );
}
